import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
} from "@deere/fuel-react";
import React from "react";
import ReasonCodeDetailedPanel from "../../components/interestBearing/ReasonCodeDetailedPanel";
import { ROLES } from "../../constants/constant";
import { getUserRole } from "../../utils/utils";
import { useSelector } from "react-redux";
import CustomRates from "../../components/interestBearing/CustomRates";
import { Tooltip } from "@mui/material";

const ModalMUI = (props) => {
  const {
    type,
    open,
    row,
    rateTypeId,
    delaerId,
    dealerName,
    entity,
    handleCloseModal,
    handleSaveModal,
    rateTypeIdAndRateTypeMap,
    rateTypeList,
    rateTypeAndRateTypeIdMap,
    rateTypeAndRateMap,
    handleCustomRatesEditedData,
    dealerRateTypeAndRatesMapping,
    handleDealerRCEditedData,
    startEndDataAndFisMonthMap,
    countryCodeMap,
    selectedMonth,
    selectedCountry,
    isParentLocked,
  } = props;

 const userData = useSelector((state) => state.userState.userData);
  const isCCM = getUserRole(userData) === ROLES.CCM;

  const handleEditedData = (data) => {
    handleDealerRCEditedData(data);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleCloseModal}
        maxWidth={"none"}
        maxHeight={"auto"}
      >
        <ModalTitle>
          {type === "ReasonCodes"
            ? "Edit Rates by Reason Code"
            : type === "CustomRates"
              ? " Custom Rates"
              : "Welcome to Modal"}
        </ModalTitle>
        <ModalContent>
          {type === "ReasonCodes" ? (
            <div>
              <div style={{ display: "flex", gap: "10%" }}>
                <p style={{ margin: "0px",width:"27%" }}>                  
                  <b>Dealer ID :</b> {delaerId}
                </p>
                <p style={{ margin: "0px", width: "30%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  <b>Dealer Name : </b>
                    <Tooltip title={dealerName}>
                          <span>{dealerName}</span>
                    </Tooltip>
                </p>
                <p style={{ margin: "0px",width:"30%",}}>
                  <b>Entity Type :</b> {entity}
                </p>
              </div>

              <ReasonCodeDetailedPanel
                row={row}
                delaerId={delaerId}
                rateTypeIdAndRateTypeMap={rateTypeIdAndRateTypeMap}
                rateTypeList={rateTypeList}
                rateTypeAndRateTypeIdMap={rateTypeAndRateTypeIdMap}
                rateTypeAndRateMap={rateTypeAndRateMap}
                dealerRateTypeAndRatesMapping={dealerRateTypeAndRatesMapping}
                handleEditedData={handleEditedData}
                startEndDataAndFisMonthMap={startEndDataAndFisMonthMap}
                countryCodeMap={countryCodeMap}
                selectedMonth={selectedMonth}
                selectedCountry={selectedCountry}
                isParentLocked={isParentLocked}
                rateTypeId={rateTypeId}
              />
            </div>
          ) : type === "CustomRates" ? (
            <div>
              <div style={{ display: "flex", gap: "5%" }}>
                <p style={{ margin: "0px" }}>
                  <b>Country :</b> {selectedCountry}
                </p>
                <p style={{ margin: "0px" }}>
                  <b>Month :</b> {selectedMonth}
                </p>
              </div>
              <CustomRates
                isParentLocked={isParentLocked}
                startEndDataAndFisMonthMap={startEndDataAndFisMonthMap}
                handleCustomRatesEditedData={handleCustomRatesEditedData}
                countryCodeMap={countryCodeMap}
                selectedMonth={selectedMonth}
                selectedCountry={selectedCountry}
              />
            </div>
          ) : (
            <div></div>
          )}
        </ModalContent>
        <ModalActions>
          {isCCM && !isParentLocked ? (
            <Button variant="primary" onClick={handleSaveModal}>
              Save
            </Button>
          ) : (
            <></>
          )}
          {isCCM && !isParentLocked && (
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          )}
        </ModalActions>
      </Modal>
    </div>
  );
};

export default ModalMUI;
